

export const generateGuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {  
        var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);  
        return v.toString(16);  
     });
}

export const normalizeChatSearches = (arr: any[]) => {
    const currentDate = new Date();
    const todayStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const prev7DaysStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 6);
    const prev30DaysStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 29);
    let normalizeArr: any[] = [];
    normalizeArr.push({
        groupText: 'Today',
        data: arr.filter(obj => obj?.date >= todayStart)
    });
    normalizeArr.push({
        groupText: 'Previous 7 Days',
        data: arr.filter(obj => obj?.date >= prev7DaysStart && obj?.date < todayStart)
    });
    normalizeArr.push({
        groupText: 'Previous 30 Days',
        data: arr.filter(obj => obj?.date >= prev30DaysStart && obj?.date < prev7DaysStart)
    });
    return normalizeArr;
}


  export const dummyStringContent = 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Velit, ipsam explicabo repellendus odit similique asperiores libero itaque delectus vitae quidem quaerat, pariatur iste beatae quae. Perferendis quam voluptatibus dicta delectus voluptates aut non molestiae itaque necessitatibus rem impedit fugiat deserunt, eaque officia sunt ullam at molestias quos earum? Similique magnam beatae laborum, cumque odio assumenda ullam laudantium sint consectetur eius iure sunt eligendi fuga modi tempora mollitia fugiat veritatis. Id corporis, libero iure consectetur perferendis fugiat impedit rerum cum cupiditate obcaecati adipisci veniam odit aut eum voluptates minima, dolor maiores. Aspernatur vitae culpa, officiis laudantium quam expedita ratione saepe libero?<br>Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda pariatur nostrum quo voluptatem omnis dolores, debitis illum, placeat esse cupiditate quam laboriosam ad vero exercitationem harum quis, inventore modi dolorem atque sed provident. Vero officia deserunt ipsum recusandae odit quisquam, voluptates quae, corporis deleniti repellat nemo adipisci nihil ducimus possimus, ad doloribus! Nisi ducimus doloribus deleniti nam magnam consequuntur delectus possimus reiciendis deserunt quam accusantium eligendi nostrum, sed ad perferendis exercitationem non! Suscipit officiis doloribus amet, dicta voluptatem voluptatibus porro repellat, beatae temporibus placeat tempora unde odio voluptates corporis asperiores! Nulla iure id fugit, sit illo sapiente. Vero, nihil incidunt!';
  
